import MaterialTable from 'material-table';
import React from 'react';
import { ACCOUNT_USAGE } from '../constants/ApiEndpoints';
import { makePostRequest } from '../helpers/biztechAxiosRequest';
import loadingGif from '../assets/loading.gif';
import blueSearchIcon from '../assets/bluesearch.png';

function SearchBox(props: {
  handleKeyPress: (event: { key: string }) => void;
  customerAccountIdsString: string;
  handleChange: (event: { target: { name: string; value: string } }) => void;
  checkAccountsUsage: (customerAccountIds: string[]) => void;
}) {
  return (
    <div className="SearchContainer">
      <div className="SearchBarArea">
        <div className="SearchBar">
          <input
            className="SearchBox"
            placeholder="Search Customer Account Ids ..."
            onKeyPress={props.handleKeyPress}
            value={props.customerAccountIdsString}
            onChange={props.handleChange}
            type="text"
            name="customerAccountIdsString"
            required
          />
          <img
            src={blueSearchIcon}
            alt="Search Icon"
            className="SearchButton"
            onClick={props.checkAccountsUsage as any}
          />
        </div>
      </div>
    </div>
  );
}

export default class AccountUsage extends React.Component<{}> {
  state = {
    customerAccountIds: [] as string[],
    customerAccountIdsString: '',
    usageData: [],
    loading: false,
    errorMessage: ''
  };

  checkCustomerAccountsUsage = () => {
    const customerAccountIds = this.state.customerAccountIdsString
      .split(',')
      .map(str => str.trim())
      .filter(str => str !== '')
      .filter((value, index, array) => array.indexOf(value) === index);
    this.setState({
      customerAccountIds: customerAccountIds
    });
    this.setState({ loading: true });
    makePostRequest(ACCOUNT_USAGE, {
      SALESFORCE_ACCOUNT_IDS: customerAccountIds
    })
      .then((result: any) => {
        this.setState({
          usageData: result.data
        });
        this.setState({ loading: false });
      })
      .catch(error => {
        this.setState({ errorMessage: 'Sorry, something went wrong !' });
        this.setState({ loading: false });
      });
  };

  handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter') {
      this.checkCustomerAccountsUsage();
    }
  };

  isValidCustomerAccountId = (customerAccountId: string) => {
    return /^001[a-z A-Z 0-9]{15}/.test(customerAccountId);
  };

  handleChange = (event: { target: { name: string; value: string } }) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    if (this.state.loading) {
      return (
        <div>
          {' '}
          <br />
          <br /> <br /> <img src={loadingGif} alt="Please wait" />{' '}
          <h1>processing ...</h1>{' '}
        </div>
      );
    }

    if (this.state.errorMessage) {
      return (
        <div>
          <br />
          <h1>{this.state.errorMessage}</h1>{' '}
        </div>
      );
    }
    if (!this.state.loading) {
      return (
        <>
          <h2>Accounts Usage</h2>
          <SearchBox
            handleKeyPress={this.handleKeyPress}
            customerAccountIdsString={this.state.customerAccountIdsString}
            handleChange={this.handleChange}
            checkAccountsUsage={this.checkCustomerAccountsUsage}
          />

          {this.state.customerAccountIdsString !== '' &&
            this.state.usageData.length !== 0 && (
              <div
                id="accountUsageTable"
                style={{
                  margin: '30px',
                  padding: '10px'
                }}
              >
                {this.state.customerAccountIds.map(customerAccountId => {
                  return this.isValidCustomerAccountId(customerAccountId) ? (
                    <div id="accountUsageTableBlock">
                      <h3>Customer Account Id : {customerAccountId}</h3>
                      <MaterialTable
                        title=""
                        columns={[
                          {
                            title: 'CUSTOMER_ACCOUNT_ID',
                            field: 'CUSTOMER_ACCOUNT_ID'
                          },
                          { title: 'ACTIVITY_TYPE', field: 'ACTIVITY_TYPE' },
                          { title: 'CNT', field: 'CNT' },
                          {
                            title: 'MIN_ACTIVITY_DATE',
                            field: 'MIN_ACTIVITY_DATE'
                          },
                          {
                            title: 'MAX_ACTIVITY_DATE',
                            field: 'MAX_ACTIVITY_DATE'
                          }
                        ]}
                        options={{
                          paging: false,
                          search: false,
                          sorting: false,
                          grouping: false,
                          columnsButton: false,
                          showTitle: false,
                          toolbar: false
                        }}
                        data={this.state.usageData.filter(
                          (data: any) =>
                            data.CUSTOMER_ACCOUNT_ID === customerAccountId
                        )}
                      />
                    </div>
                  ) : (
                    <h3>Invalid Customer Account Id : {customerAccountId}</h3>
                  );
                })}
              </div>
            )}

          {this.state.customerAccountIds.length === 0 && (
            <div>
              <h3>
                Please enter Customer Account Ids(Separated By " , ") to search
                usage
                {this.state.customerAccountIds}
              </h3>
            </div>
          )}
        </>
      );
    }
  }
}
